import React, { Component } from 'react';
import {Popover,PopoverBody,PopoverHeader} from 'reactstrap';
import Tooltip from '../TooltipIcon/TooptipIcon';
import { isBwaiScope } from '../../../utils/bwaiScope';
import './Popover.css';

class OoPopover extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen : false
    }
  }

  render() {
    const {isOpen} = this.state;
    const {target,headerText,bodyText,placement, css_class} = this.props;
    /* The bwai restyle ships in Trivvy only — OurOffice still runs the old
       design, and this component is shared by both products. */
    const bwaiClass = isBwaiScope() ? 'bwai-tip' : '';
    return(
      <span>
        <span
          id={target}
          className={`mr10 info_icon_mk ${css_class?css_class:''}`}
          onClick={() => { this.setState((p) => ({isOpen:!p.isOpen })) }}>
          <Tooltip />
        </span>
        <Popover placement={placement ? placement : `right`}
        className={`${bwaiClass} ${css_class?css_class:''}`.trim()}
          isOpen={isOpen}
          target={target}
          toggle={() => { this.setState((p) => ({isOpen:!p.isOpen })) }}>
          <PopoverHeader className="popover-header-tooltip">
            {headerText}
            <span
              className="oo_popover_close"
              role="button"
              aria-label="Close"
              onClick={() => { this.setState({ isOpen: false }) }}>
              &times;
            </span>
          </PopoverHeader>
          <PopoverBody className="popover-body-tooltip">
            {bodyText}
          </PopoverBody>
        </Popover>
      </span>
    )
  }
}

export default OoPopover;
